import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/guochao/banner.jpg'
import navColor from '../../assets/guochao/nav/color.jpg'
import navBg from '../../assets/guochao/nav/nav_bg.png'
import navBgFixed from '../../assets/guochao/nav/nav_bg_fixed.png'

import far1 from '../../assets/guochao/nav/far1.png'
import far1_active from '../../assets/guochao/nav/far1_active.png'
import far2 from '../../assets/guochao/nav/far2.png'
import far2_active from '../../assets/guochao/nav/far2_active.png'
import far3 from '../../assets/guochao/nav/far3.png'
import far3_active from '../../assets/guochao/nav/far3_active.png'
import son1 from '../../assets/guochao/nav/son1.png'
import son1_active from '../../assets/guochao/nav/son1_active.png'
import son2 from '../../assets/guochao/nav/son2.png'
import son2_active from '../../assets/guochao/nav/son2_active.png'
import third1_1 from '../../assets/guochao/nav/third1_1.png'
import third1_1_active from '../../assets/guochao/nav/third1_1_active.png'
import third1_2 from '../../assets/guochao/nav/third1_2.png'
import third1_2_active from '../../assets/guochao/nav/third1_2_active.png'
import third1_3 from '../../assets/guochao/nav/third1_3.png'
import third1_3_active from '../../assets/guochao/nav/third1_3_active.png'
import third1_4 from '../../assets/guochao/nav/third1_4.png'
import third1_4_active from '../../assets/guochao/nav/third1_4_active.png'
import third2_1 from '../../assets/guochao/nav/third2_1.png'
import third2_1_active from '../../assets/guochao/nav/third2_1_active.png'
import third2_2 from '../../assets/guochao/nav/third2_2.png'
import third2_2_active from '../../assets/guochao/nav/third2_2_active.png'
import third2_3 from '../../assets/guochao/nav/third2_3.png'
import third2_3_active from '../../assets/guochao/nav/third2_3_active.png'
import third3_1 from '../../assets/guochao/nav/third3_1.png'
import third3_1_active from '../../assets/guochao/nav/third3_1_active.png'
import third3_2 from '../../assets/guochao/nav/third3_2.png'
import third3_2_active from '../../assets/guochao/nav/third3_2_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(155),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(155),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(155),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    padding: `${calcRemFn(22)} ${calcRemFn(40)} 0`
  },
  topBtnBaseCss: {
    width: calcRemFn(95),
    height: calcRemFn(32),
    padding: `0 ${calcRemFn(3)}`
  },
  bottomBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${calcRemFn(8)} 0 ${calcRemFn(4)}`
  },
  bottomBtnBaseCss: {
    width: calcRemFn(46),
    height: calcRemFn(22.5),
    padding: `0 ${calcRemFn(15)}`
  },
  thirdBtnLayout: {
    padding: `0 ${calcRemFn(83)}`,
  },
  thirdBtnBaseCss: {
    width: calcRemFn(46),
    height: calcRemFn(22.5),
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: false,
        img: son1,
        img_actived: son1_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: false,
        img: son1,
        img_actived: son1_active
      }
    ]
  },
  third: {
    top1_i1: [
      {
        key: '_t1',
        show: true,
        img: third1_1,
        img_actived: third1_1_active
      },
      {
        key: '_t2',
        show: true,
        img: third1_2,
        img_actived: third1_2_active
      },
      {
        key: '_t3',
        show: true,
        img: third1_3,
        img_actived: third1_3_active
      },
      {
        key: '_t4',
        show: true,
        img: third1_4,
        img_actived: third1_4_active
      }
    ],
    top1_i2: [
      {
        key: '_t1',
        show: true,
        img: third1_1,
        img_actived: third1_1_active,
        style: {
          paddingLeft: `${calcRemFn(42)}`
        }
      },
      {
        key: '_t2',
        show: true,
        img: third1_2,
        img_actived: third1_2_active,
        style: {
          paddingRight: `${calcRemFn(42)}`
        }
      }
    ],
    top2_i1: [
      {
        key: '_t1',
        show: true,
        img: third2_1,
        img_actived: third2_1_active,
        style: {
          width: `${calcRemFn(73.5)}`,
          height: `${calcRemFn(22.5)}`,
          paddingTop: `${calcRemFn(20)}`
        }
      },
      {
        key: '_t2',
        show: true,
        img: third2_2,
        img_actived: third2_2_active,
        style: {
          width: `${calcRemFn(73.5)}`,
          height: `${calcRemFn(22.5)}`,
          paddingTop: `${calcRemFn(20)}`
        }
      },
      {
        key: '_t3',
        show: true,
        img: third2_3,
        img_actived: third2_3_active,
        style: {
          width: `${calcRemFn(73.5)}`,
          height: `${calcRemFn(22.5)}`,
          paddingTop: `${calcRemFn(20)}`
        }
      }
    ],
    top3_i1: [
      {
        key: '_t1',
        show: true,
        img: third3_1,
        img_actived: third3_1_active,
        style: {
          padding: `${calcRemFn(20)} 0 0 ${calcRemFn(42)}`
        }
      },
      {
        key: '_t2',
        show: true,
        img: third3_2,
        img_actived: third3_2_active,
        style: {
          padding: `${calcRemFn(20)} ${calcRemFn(42)} 0 0`
        }
      }
    ]
  }
}

const top1_1_prod = 102131
const top1_2_prod = 106778
const top2 = 102132
const top3 = 102130


const pictureList = [
  {
    key: '1_1_1',
    picNum: 2,
    pid: top1_1_prod
  },
  {
    key: '1_1_2',
    picNum: 2,
    pid: top1_1_prod
  },
  {
    key: '1_1_3',
    picNum: 3,
    pid: top1_1_prod
  },
  {
    key: '1_1_4',
    picNum: 3,
    pid: top1_1_prod
  },
  {
    key: '1_2_1',
    picNum: 2,
    pid: top1_2_prod
  },
  {
    key: '1_2_2',
    picNum: 3,
    pid: top1_2_prod
  },
  {
    key: '2_1_1',
    picNum: 2,
    pid: top2
  },
  {
    key: '2_1_2',
    picNum: 1,
    pid: top2
  },
  {
    key: '2_1_3',
    picNum: 2,
    pid: top2
  },
  {
    key: '3_1_1',
    picNum: 2,
    pid: top3
  },
  {
    key: '3_1_2',
    picNum: 2,
    pid: top3
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/guochao/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[0]}_i${indexArr[1]}_t${indexArr[2]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      thirdName: `_t${indexArr[2]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.push({
  son: [
    require('../../assets/guochao/ctn/4_1_1_1.jpg')
  ],
})

const topDiff = {
  firstSon: '_i1',
  firstThird: '_t1'
}

export default {
  title: '中国的海马体',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
